import { render, staticRenderFns } from "./GearIcon.vue?vue&type=template&id=9064d97a&"
import script from "./GearIcon.vue?vue&type=script&lang=js&"
export * from "./GearIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports